import { useState, ChangeEvent } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router-dom';
import PageHeader from './PageHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Container, Tabs, Tab, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import PermitTheme from './PermitTheme';
import NotificationsTab from './NotificationsTab';
import TownshipUserAccess from '../TownshipUserAccess';
import UserManagement from '../User_Management/UserManagement';
import FinanceConfiguration from '../FinanceConfiguration';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import TemplateList from '../TemplateConfiguration/TemplateList';
import DocumetnConfiguration from '../DocumetnConfiguration';
import PermitConfiguration from '../PermitConfiguration';
import {
  canAccessTownshipConfiguration,
  getTownshipConfigurationDeniedRedirect,
  isTownshipConfigurationTownshipAllowed
} from 'src/utils/townshipAdminAccess';

const TabsWrapper = styled(Tabs)(
  () => `
    .MuiTabs-scrollableX {
      overflow-x: auto !important;
    }
`
);

function ManagementAdminConfiguration() {
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const { townshipId } = useParams<{ townshipId: string }>();
  const isFinanceManager = userDetails?.isFinanceManager;

  if (!canAccessTownshipConfiguration(userDetails)) {
    return (
      <Navigate
        to={getTownshipConfigurationDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  if (!isTownshipConfigurationTownshipAllowed(userDetails, townshipId)) {
    return (
      <Navigate
        to={getTownshipConfigurationDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  // Default tab logic
  const defaultTab = isFinanceManager ? 'finance_configuration' : 'theme';
  const [currentTab, setCurrentTab] = useState<string>(defaultTab);

  const tabs = [
    { value: 'theme', label: 'Theme' },
    { value: 'documents', label: 'Documents' },
    // { value: 'template', label: 'Templates' },
    { value: 'user_access', label: 'User Access' },
    { value: 'finance_configuration', label: 'Finance Configuration' },
    { value: 'user_management', label: 'User Management' },
    { value: 'notifications', label: 'Notifications' },
    { value: 'permit_configuration', label: 'Permit Configuration' },
  ];

  // If user is a finance manager, only show the Finance Configuration tab
  if (isFinanceManager) {
    tabs.length = 0; // Clear all tabs
    tabs.push({
      value: 'finance_configuration',
      label: 'Finance Configuration'
    }); 
  }

  const handleTabsChange = (
    event: ChangeEvent<unknown>,
    value: string
  ): void => {
    setCurrentTab(value);
  };

  return (
    <>
      <Helmet>
        <title>Admin Township Configuration</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper>
      <Container sx={{maxWidth : "100% !important", pb:{xs: 8, sm:"auto"}}}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <TabsWrapper
              onChange={handleTabsChange}
              value={currentTab}
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="primary"
            >
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </TabsWrapper>
          </Grid>
          <Grid item xs={12}>
            {currentTab === 'theme' && <PermitTheme />}
            {currentTab === 'documents' && <DocumetnConfiguration />}
            {currentTab === 'template' && <TemplateList />}
            {currentTab === 'user_access' && <TownshipUserAccess />}
            {currentTab === 'finance_configuration' && <FinanceConfiguration />}
            {currentTab === 'user_management' && <UserManagement />}
            {currentTab === 'notifications' && <NotificationsTab />}
            {currentTab === 'permit_configuration' && <PermitConfiguration />}
          </Grid>
        </Grid>
      </Container>
      {/* <Footer /> */}
    </>
  );
}

export default ManagementAdminConfiguration;
